// extracted by mini-css-extract-plugin
export default {"tableButton-container":"Button3_tableButton-container__qdtRt","image":"Button3_image__z+dq-"};